<template>
  <div id="ArticleEdit">
    <!-- success msg component 
    <Success :msg="msg" v-show="success" />
    -->
    <!-- edit user which has user data as prop -->
    <ProductForm :product="product" :submitForm="updateRow" buttonText="Actualizar" hasArticle=true :hasArticleID='product.pricelist_id' />
  
  </div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import ProductForm from "@/components/ProductForm";
//import Success from "./Success";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
// import router from '@/router';


export default {
  name: "ProductEdit",
  computed:{
    ...mapState(['currentUser']),    
  },
  components: {
    ProductForm,
    //Success,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      success: false,
      msg: "",
      id:23
    };
  },
  methods: {
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
    async updateRow(productInfo){
      //updateRow(user) {     
      // alert('hola: '+ productInfo.title) ;
      try{        
          this.showLoading({titulo:"Accediendo información",color:"warning"})  
          icheckApi().post(`/articulos/update/${productInfo.id}`,JSON.stringify(productInfo)).then((response)=>{        
            if(!response.data.error){                            
              this.$swal("Genial!",response.data.message, "success");
            }else{
              this.$swal("Error!",response.data.message, "error");
            }                                    
          });              
        }catch(error){
          // console.log(this.$route.name+' '+error);          
        }finally{
          this.hiddenLoading()
        }
    }
  },
  created(){
    //Producto ID
    //this.getDataProduct(23);
  },
  updated(){
    //this.getDataProduct(23);
    //alert('cambio')
  }
};
</script>